import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/index'
import brief from '@/view/brief'
Vue.use(Router)

export default new Router({
    // mode: 'history', // require service support
    routes: [{
            path: '/',
            name: 'Index',
            component: Index,
            meta: {
                title: '室内导览'
            }
        },
        {
            path: '/brief',
            name: 'brief',
            component: brief,
            meta: {
                title: '简介'
            }
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js